import React, { useState, useEffect, useCallback, ChangeEvent, useRef } from "react";
import { Box, Button, Paper, TextField, Checkbox } from "@mui/material";
import { useNavigate } from "react-router";
import {useDispatch, useSelector} from "react-redux"
import { setUserInfo } from "../../../redux/slice/user";
import { useCookies } from "react-cookie";
import CancelIcon from '@mui/icons-material/Cancel';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import ExpandCircleDownIcon from '@mui/icons-material/ExpandCircleDown';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import AppHeader from "../../component/AppHeader";
import api from "../../../API";
import NKIUploadDialog from './NKIUploadDialog';
import { SearchBackDrop } from "../../component/common/SearchBackDrop";

const ScriptListPage = (props:any) => {

  const [script, setScript] = useState([]);
  const [scriptCount, setScriptCount] = useState(0);

  const [uploadDialogOpen, setUploadDialogOpen] = useState<boolean>(false);

  const auth = useSelector((state:any)=> state.userInfo.data)
  const speaker1 = auth.user.user_id;
  // console.log('userInfo',speaker1)
  const email = auth.user.email;
  
  const myScriptList = async () => {
    api.get('/myScriptList',{params:{email: email}})
    .then((res:any) => {
      console.log("마이 스크립트 ", res.data.datas); setScript(res.data.datas); setScriptCount(res.data.datas.length) 
    })
      // alert("파일 업로드가 완료되었습니다.");
    .catch((error:any) => {console.error('에러',error.response);})
    // alert("파일 업로드 실패. " + error.response.data.error);
  }

  const allScriptDownload = async (download_type:string) => {
    setBackdrop(true)
    await api.get('/downloadScript',{params:{email:email,download_type:download_type}, responseType: 'blob' })
    // await api.get('/downloadScriptByAdmin',{params:{email:email}, responseType: 'blob' })
    .then(response => {
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      const month = String(currentDate.getMonth() + 1).padStart(2, '0');
      const day = String(currentDate.getDate()).padStart(2, '0');

      const download_date = `${year}_${month}_${day}`

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', "스크립트다운("+download_type+")_"+download_date+".zip");
      document.body.appendChild(link);
      link.click();
      setBackdrop(false)
      alert("스크립트 다운로드가 완료되었습니다.");
    })
      // alert("파일 업로드가 완료되었습니다.");
    .catch((error:any) => {setBackdrop(false); console.error('에러',error.response);})
    // alert("파일 업로드 실패. " + error.response.data.error);
  }

  useEffect(()=>{
    myScriptList()
  },[])

  const [backdrop, setBackdrop] = useState<boolean>(false)
  
  return (
    <Paper sx={{borderTop: "4px solid #3e36a5", width:"100%", height:"550px", overflow: "hidden"}}>
      <Box>
          <Box sx={{padding:"30px"}}>
            <Box sx={{display:"flex", alignItems:"center"}}>
              <Box sx={{marginLeft:"2px", marginRight:"20px", fontWeight:700, fontSize: "24px", letterSpacing:"-2px"}}>할당된 스크립트 목록 총 : {<b style={{color:"#03cf5d"}}>{scriptCount}</b>}건</Box>
              <Button variant="contained" sx={{color:"blue", border:"2px solid blue",height:"30px",":hover":{backgroundColor:"blue" , color:"#fff"} , backgroundColor:"#fff",display:"flex", marginLeft:"auto",marginRight:"20px",marginBottom:"8px"}} onClick={()=> allScriptDownload("모두")}>모두 다운로드</Button>
              <Button variant="contained" sx={{color:"blue", border:"2px solid #3fb92e",height:"30px",":hover":{backgroundColor:"blue" , color:"#fff"} , backgroundColor:"#fff",display:"flex",marginRight:"20px",marginBottom:"8px"}} onClick={()=> allScriptDownload("업로드대기")}>업로드대기 다운로드</Button>
              <Button variant="contained" sx={{color:"green", border:"2px solid green",height:"30px",":hover":{backgroundColor:"green" , color:"#fff"} , backgroundColor:"#fff",display:"flex", marginLeft:"20px",marginRight:"50px",marginBottom:"8px"}} onClick={()=> setUploadDialogOpen(true)}>파일업로드</Button>
            </Box>
            {backdrop && ( <SearchBackDrop message={"다운로드 중..."}/> )}
            {uploadDialogOpen ? <NKIUploadDialog speaker1={speaker1} myScriptList={myScriptList} setUploadDialogOpen={setUploadDialogOpen} /> : ""}
            <hr style={{borderTop : "2px solid #3e36a5", marginTop:"0px"}}></hr>
            <TableContainer sx={{maxHeight:"440px"}}>
              <Table sx={{ minWidth: 1000 }} size="small" aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell align="center"><Box sx={{fontSize:"14px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>NO</Box></TableCell>
                    <TableCell align="center"><Box sx={{fontSize:"14px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>관리 PK</Box></TableCell>
                    {/* <TableCell align="center"><Box sx={{fontSize:"14px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>주제</Box></TableCell> */}
                    {/* <TableCell align="center"><Box sx={{fontSize:"12px",width:"50px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>주제세부</Box></TableCell> */}
                    {/* <TableCell align="center"><Box sx={{fontSize:"14px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>할당정보</Box></TableCell> */}
                    <TableCell align="center"><Box sx={{fontSize:"14px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>할당일자</Box></TableCell>
                    <TableCell align="center"><Box sx={{fontSize:"14px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>상태</Box></TableCell>
                    <TableCell align="center"><Box sx={{fontSize:"14px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>업로드일자</Box></TableCell>
                    {/* <TableCell align="center"><Box sx={{fontSize:"14px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>요약</Box></TableCell>
                    <TableCell align="center"><Box sx={{fontSize:"14px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>키워드</Box></TableCell> */}
                    {/* <TableCell align="center"><Box sx={{color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>할당워커ID</Box></TableCell> */}
                    {/* <TableCell align="center"><Box sx={{color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>녹음파일</Box></TableCell>
                    <TableCell align="center"><Box sx={{color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>자막파일</Box></TableCell>
                    <TableCell align="center"><Box sx={{color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>사진파일</Box></TableCell> */}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {script.length > 0 ? script.map((row:any, idx:number) => (
                    <React.Fragment key={idx+1}>
                      <TableRow
                        key={idx+1}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                      >
                        <TableCell component="th" scope="row" align="center">{idx+1}</TableCell>
                        <TableCell align="left"><Box sx={{fontSize:"14px"}}>{row.mgm_con_pk}</Box></TableCell>
                        {/* <TableCell align="left"><Box sx={{fontSize:"14px"}}>{row.con_type}</Box></TableCell> */}
                        {/* <TableCell align="left"><Box sx={{fontSize:"12px"}}>{row.con_type}</Box><Box sx={{fontSize:"12px"}}>({row.sub_subject})</Box></TableCell> */}
                        {/* <TableCell align="left"><Box sx={{fontSize:"12px"}}>{row.worker_name}</Box><Box sx={{fontSize:"12px"}}>({row.worker_id})</Box></TableCell> */}
                        <TableCell align="left"><Box sx={{fontSize:"14px"}}>{row.asg_date}</Box></TableCell>
                        <TableCell align="left">
                          <Box sx={{fontSize:"14px"}}>
                            <TableCell align="left" sx={{fontWeight:600}}>
                              <Button sx={{fontWeight:700, color:"#fff", backgroundColor: ((row.col_pk !== "None" && row.col_pk !== "") ? "#1152a7" : "#3fb92e")}}>{(row.col_pk !== "None" && row.col_pk !== "") ? "업로드완료":"업로드대기"}</Button>
                            </TableCell>
                          </Box>
                        </TableCell>
                        <TableCell align="left"><Box sx={{fontSize:"14px"}}>{row.upload_date !== "" ? row.upload_date : "-"}</Box></TableCell>
                        {/* <TableCell align="left"><Box sx={{fontSize:"12px"}}>{row.summary}</Box></TableCell> */}
                        {/* <TableCell align="left"><Box sx={{fontSize:"12px"}}>{row.knowledge}</Box></TableCell> */}
                        {/* <TableCell align="left">{row.worker_id}</TableCell> */}
                        {/* <TableCell align="left">{sample.file_srt}</TableCell>
                        <TableCell align="left">{sample.file_photo}</TableCell> */}
                      </TableRow>
                    </React.Fragment>
                  )):""}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
          
        </Box>
    </Paper>
  );
};

export default ScriptListPage;
